module.exports = __webpack_public_path__ + "static/composable-components-e426dea94e2e4c7290ce8304b92b45c5.png";